import React from "react";
import { Table } from "reactstrap";

import AsyncJobRow from "./row/AsyncJobRow";

const AsyncJobsTable = ({
  asyncJobs,
  handleDelete,
  downloadFile,
  isExport,
}) => {
  const rows = asyncJobs.map((entry) => (
    <AsyncJobRow
      key={entry.id}
      entry={entry}
      handleDelete={handleDelete}
      downloadFile={downloadFile}
      isExport={isExport}
    />
  ));

  return (
    <React.Fragment>
      {asyncJobs.length ? (
        <Table className="async-jobs-table">
          <thead className="thead-light">
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Created By</th>
              <th>Start process</th>
              <th>End process</th>
              <th className="center">Action result</th>
              {isExport ? <th className="center">Action</th> : null}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default AsyncJobsTable;



// WEBPACK FOOTER //
// ./src/features/organization/pages/async-jobs/async-jobs-table/AsyncJobsTable.jsx